import {
  all,
  call,
  put,
  select,
  take
} from 'redux-saga/effects';
import {
  request
} from 'utils/request';
import {
  dexfRequest,
  dexfGlobalRequest
} from 'utils/dexf';
import {
  LOAD_DATA
} from '../constants';
import {
  optionsLoaded,
  loadingData,
  loadingError
} from '../actions';
import {
  generateOptions
} from '../generators/options';
import {
  loadedLanguageSelector
} from '../selectors';

const runningFromLocal = location.host.startsWith("localhost");

export function* loadData({ country, language }) {
  try {
    const loaded = yield select(loadedLanguageSelector);
    if (loaded.language === language && loaded.country === country) {
      console.log('Data already loaded for the given country and language. Exiting.');
      return;
    }

    let businessRules;

    if (runningFromLocal) {
      businessRules = yield call(request, `/addon-app/cwcalc/rules/latest/${country}/${country}/`);
    } else {
      const latestRefUrl = `/addon-app/cwcalc/rules/latest/index.json`;
      console.log('Fetching latestRef business rules from:', latestRefUrl);

      const latestRef = yield call(request, latestRefUrl);
      console.log('Fetched latestRef business rules:', latestRef);

      const latestFile = latestRef[country.toUpperCase()];
      if (!latestFile) {
        throw new Error(`No latestRef business rules entry found for country: ${country}`);
      }
      const fileUrl = `/addon-app/cwcalc/rules/${latestFile}.json`;
      console.log('Fetching business rules from:', fileUrl);
      businessRules = yield call(request, fileUrl);
      console.log('Fetched business rules:', businessRules);
    }

    yield put(loadingData(true));

    let [items, itemsGlobal] = yield all([
      call(dexfRequest, country, language, businessRules),
      call(dexfGlobalRequest, country, 'en'),
    ]);
    console.log('Fetched items:', items);
    console.log('Fetched global items:', itemsGlobal);

    if (language !== 'en') {
      items = updateGlobalProps(items, itemsGlobal);
    }

    yield put(optionsLoaded(generateOptions(businessRules, items, country, language), country, language));
    yield put(loadingData(false));
    console.log('Data loading completed successfully.');
  } catch (error) {
    console.error('Error in loadData saga:', error);

    const url = (error.response && error.response.url) || '';
    if (url.indexOf('rules') >= 0) {
      yield put(loadingError('load business rules'));
    } else if (url.indexOf('products') >= 0 || url.indexOf('items') >= 0) {
      yield put(loadingError('load item data'));
    } else if (error.message && error.message.indexOf('JSON') >= 0) {
      yield put(loadingError('parse JSON'));
    } else {
      yield put(loadingError('unknown error, check the console'));
    }
  }
}

export default function* loadDataSaga() {
  while (true) { // eslint-disable-line no-constant-condition
    // Using take to not start another load_data if we are already loading one.
    // To avoid starting multiple fetches for the same data.
    const action = yield take(LOAD_DATA);
    yield call(loadData, action);
  }
}

function updateGlobalProps(items, itemsGlobal) {
  itemsGlobal.forEach((global) => {
    let updatedItem = items.find((element) => {
      return element.ItemNo === global.ItemNo
    });
    updatedItem.ProductNameGlobal = global.ProductNameGlobal;
    updatedItem.ValidDesignTextGlobal = global.ValidDesignTextGlobal;
  });
  return items;
}